module.exports = __webpack_public_path__ + "img/cat.1a0ffbbe.gif";